import { useQuery } from "@tanstack/react-query";
import CheckBoxQuestions from "components/CheckBoxQuestions";
import { Form, Formik } from "formik";
import { useEffect, useMemo } from "react";
import { Spinner } from "react-bootstrap";
import { getAilmentGroupQuestion } from "services/getApis";
import { ErrorHandler } from "utils/toast";

const SymptomReview = ({ ailmentId, onContinue }) => {
  const { data, isError, error, isLoading, isFetching } = useQuery({
    queryKey: ["symptom_review", ailmentId],
    queryFn: () =>
      getAilmentGroupQuestion({
        group: "symptom_review",
        id: ailmentId,
      }),
    retry: 3,
  });

  const allSymptomQuestions = useMemo(() => data?.payload || [], [data]);

  useEffect(() => {
    if (isError) {
      ErrorHandler(error);
    }
  }, [error, isError]);

  const initialValues = allSymptomQuestions.reduce((acc, question) => {
    acc[question.id] = null;
    return acc;
  }, {});

  const chunkedQuestions = useMemo(() => {
    const cq = [];
    for (let i = 0; i < allSymptomQuestions.length; i += 2) {
      cq.push(allSymptomQuestions.slice(i, i + 2));
    }

    return cq;
  }, [allSymptomQuestions]);

  const handleSubmit = (values) => {
    console.log("Form submitted:", values);
    onContinue?.(values);
  };

  return (
    <>
      <h2 className="question-title">Describe What You Feel</h2>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values }) => {
          const valuesArray = Object.values(values);
          const isAllFilled =
            valuesArray.length > 0 &&
            valuesArray.every(
              (val) => val !== null && val !== "" && val !== undefined
            );

          return (
            <Form className="form-section">
              {isLoading && isFetching ? (
                <div className="d-flex  justify-content-center  my-3">
                  <Spinner animation="border" />
                </div>
              ) : (
                <>
                  <div className="symptoms-grid">
                    {chunkedQuestions.map((row, rowIndex) => (
                      <div key={rowIndex} className="symptom-row">
                        {row.map((question) => (
                          <div key={question.id} className="symptom-item">
                            <CheckBoxQuestions
                              name={question.id}
                              label={question.question}
                            />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                  <button
                    type="submit"
                    className={`continue-btn ${
                      isAllFilled ? "active" : "disabled"
                    }`}
                    disabled={!isAllFilled}
                  >
                    Continue
                  </button>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default SymptomReview;
